import { useCart } from 'context/cart/CartContext'
import { ICartItem } from 'context/cart/models/ICart'
import { ICheckStockProduct } from 'models/inventory/ICheckStock'
import React, { FC, useState } from 'react'
import styles from './CartItem.module.scss'
import { Icon } from '@material-ui/core'
import { useCatalog } from 'context/catalog/CatalogContext';
import { moneyMaskNumber } from 'utils/mask/money'

const ID_ONE_PRODUCT_PER_TIME = 'e703e514-652d-0230-7593-5697f769bcd1';

export interface ICartItemProps {
    cartItem: ICartItem
    stockProduct?: ICheckStockProduct
}

const CartItem: FC<ICartItemProps> = ({ cartItem, stockProduct }) => {
    const { removeCarItem, addCartItem } = useCart();
    const { catalog } = useCatalog();
    const [hasImageError, setHasImageError] = useState(false);

    const isUnavailable = stockProduct !== undefined && !stockProduct.isAvailable;

    return (
        <div className={`${styles.container} ${isUnavailable ? styles.unavailable : ''}`}>
            {
                !hasImageError ?
                    <img src={cartItem.imageUrl} alt="" className={styles.image} onError={() => setHasImageError(true)} /> :
                    <div className={styles.imageFallback}>
                        <Icon className={styles.icon}>no_photography</Icon>
                    </div>
            }

            <div className={styles.content}>
                <span className={styles.name}>{cartItem.name}</span>
                {cartItem.description && <p className={styles.description}>{cartItem.description}</p>}

                {
                    !!cartItem.orderComposition?.length &&
                    <div className={styles.compositions} >
                        {cartItem.orderComposition?.map((composition) => (
                            <div className={styles.composition} key={composition.id}>
                                <b>{composition.description.toLowerCase()}</b>
                                <div className={styles.compositionNameContent}>
                                    {composition.compositionItems.map(item => (
                                        <span key={item.id}>{item.quantity}x {item.description.toLowerCase()}<br /></span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                }

                <span className={styles.price}>{moneyMaskNumber(cartItem.totalPrice)}</span>

                {isUnavailable && (
                    <span className={styles.stockWarning}>{stockProduct.reason}</span>
                )}
            </div>

            <div className={styles.totalContainer}>
                {ID_ONE_PRODUCT_PER_TIME !== catalog?.id && (
                    <div className={styles.quantityContainer}>
                        <button
                            type="button"
                            className={styles.iconButton}
                            onClick={() => removeCarItem(cartItem.id, 1)}
                        >
                            <Icon>remove</Icon>
                        </button>
                        <span className={styles.quantityText}>
                            {cartItem.quantity}
                        </span>
                        <button
                            type="button"
                            className={styles.iconButton}
                            onClick={() => addCartItem(cartItem.id, 1)}
                        >
                            <Icon>add</Icon>
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
export default CartItem
